//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

import { Select } from "@chakra-ui/react";
import React from "react";

// ALL_COMPONENTS is the sentinel option value meaning "no usage-component
// filter" - the chart/breakdown show every component. It is not a valid
// component value, so it can never collide with a real one.
export const ALL_COMPONENTS = "";

// usageComponentOptions mirrors (both `value` and `text`) idashboard's
// `creditUsageKindOptions` in
// idashboard/frontend/src/dashboard/organization/UsageItemFilterView.tsx, so
// the internal and customer-facing dashboards agree on what each Billing 2.0
// component is called.
//
// KEEP IN SYNC with idashboard's `creditUsageKindOptions` AND the canonical Go
// list `BillingV2UsageItemKinds` in apis/usage/v1/kinds.go, which already
// asks for creditUsageKindOptions to be updated when a new V2 kind is added
// - adding a kind there means adding it here too. Deliberately excludes the
// deprecated V1 kinds also listed in kinds.go: this is a customer-facing
// filter over Billing 2.0 usage only.
export const usageComponentOptions = [
  { value: "CPUHour", text: "CPU Hour" },
  { value: "MemoryHour", text: "Memory Hour" },
  { value: "StorageHour", text: "Storage Hour" },
  { value: "StoragePerformanceHour", text: "Storage Performance Hour" },
  { value: "GPUHour", text: "GPU Hour" },
  { value: "DeploymentAEU", text: "Deployment AEU" },
  { value: "NetworkUsageSize", text: "Network Size" },
  { value: "CloudStorageHour", text: "Cloud Storage Hour" },
  { value: "AuditLogRequests", text: "Audit Log Requests" },
  { value: "AuditLogData", text: "Audit Log Data" },
  { value: "AddonHour", text: "Addon Hour" },
];

// UsageComponentFilter lets the viewer narrow the usage chart down to a
// single Billing 2.0 usage component (e.g. only Memory Hour), so they can
// analyse just one aspect of their consumption.
export const UsageComponentFilter = ({ value, onChange }: { value: string; onChange: (component: string) => void }) => {
  return (
    <Select value={value} onChange={(e) => onChange(e.target.value)} width="auto" minWidth="220px" aria-label="Filter usage by component">
      <option value={ALL_COMPONENTS}>All components</option>
      {usageComponentOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.text}
        </option>
      ))}
    </Select>
  );
};
